// These are not in use yet -- code ready for dynamic styles.
// See Map.svelte to set style.

import VesselProperty from "../Models/Enums/VesselProperty";
const Styles = {};
// const Styles = {
// 	Current: "mapbox://styles/geollectryan/ckb2eqgog0v3f1ipnqpzkqnax",
// 	Alerts: "mapbox://styles/geollectryan/ckb2eqgog0v3f1ipnqpzkqnax",
// 	Heatmap: "mapbox://styles/geollectryan/ckb2eqgog0v3f1ipnqpzkqnax"
// 	// Heatmap: "mapbox://styles/mapbox/light"
// };
const Layout = {
	vessel: {
		visibility: "visible",
		"icon-image": ["get", "iconImage"],
		"icon-allow-overlap": true,
		"icon-rotation-alignment": "map",
		"icon-rotate": ["number", ["get", VesselProperty.COURSE], 360],
		"icon-size": [
			"interpolate", ["linear"],
			["zoom"],
			2, 0.25,
			8, 0.4,
			16, 0.5,
			20, 0.75
		]
	},
	selectableAircraft: {
		visibility: "visible",
		"icon-image": ["get", "iconImage"],
		"icon-size": [
			"interpolate", ["linear"],
			["zoom"],
			2, 0.25,
			8, 0.4,
			16, 0.5,
			20, 0.75
		],
		"icon-allow-overlap": true,
		"icon-rotation-alignment": "map",
		"icon-rotate": ["number", ["get", "course"], 360]
	},
	historic: {
		visibility: "visible",
		"icon-image": ["get", "iconImage"],
		"icon-rotation-alignment": "map",
		"icon-rotate": ["number", ["get", VesselProperty.COURSE], 360],
		"icon-size": [
			"interpolate", ["linear"],
			["zoom"],
			6, 0.5,
			10, 1
		]
	},
	aircraft: {
		visibility: "none",
		"icon-image": "airport-15",
		"icon-size": [
			"interpolate", ["linear"],
			["zoom"],
			2, 0.5,
			6, 1.0,
			10, 2
		],
		"icon-allow-overlap": true,
		"icon-rotation-alignment": "map",
		"icon-rotate": ["number", ["get", "course"], 360]
	},
	historic_query: {
		visibility: "visible",
		"icon-image": ["get", "iconImage"],
		"icon-rotation-alignment": "map",
		"icon-rotate": ["number", ["get", VesselProperty.COURSE], 360],
		"icon-size": [
			"interpolate", ["linear"],
			["zoom"],
			6, 0.5,
			10, 1
		]
	},
	measure: {
		"line-join": "round",
		"line-cap": "round"
	},
	measureText: {
		"text-field": ["get", "description"],
		"text-anchor": "center",
		"text-justify": "auto",
		"text-size": 13,
		"text-max-width": 30,
		"text-font": ["Open Sans Bold", "Open Sans Regular", "Arial Unicode MS Regular"]
	},
	ports: {
		"icon-image": "anchor-solid",
		"icon-text-fit": "none",
		"icon-size": [
			"interpolate",
			["linear"],
			["zoom"],
			0,
			0.5,
			12,
			1.5
		],
		"icon-allow-overlap": true,
		"icon-ignore-placement": false,
		"icon-optional": false,
		"symbol-avoid-edges": false,
		"symbol-placement": "point",
		"text-optional": false,
		"text-line-height": 1.2,
		"text-max-width": 10,
		"text-transform": "none",
		"text-size": 12,
		"text-anchor": "bottom",
		"text-justify": "center",
		"text-padding": 2,
		"text-allow-overlap": true,
		"text-field": [
			"step",
			["zoom"],
			[
				"concat",
				[
					"to-string",
					["get", "PORT_NAME"]
				],
				"\n(",
				["get", "TYPE_READABLE"],
				")"
			],
			22,
			[
				"concat",
				[
					"to-string",
					["get", "PORT_NAME"]
				],
				"\n(",
				["get", "TYPE_READABLE"],
				")"
			]
		]
	},
	rfVesselPoints: {
		"icon-image": "dot-11",
		"icon-size": 1
		// ["step",
		// 	["zoom"],
		// 	0,
		// 	7, 1
		// ]

	},
	visible: {
		visibility: "visible"
	},
	invisible: {
		visibility: "none"
	}
};

const Paint = {
	ports: {
		"text-opacity": [
			"interpolate",
			["linear"],
			["zoom"],
			7,
			0,
			7.5,
			1
		],
		"icon-opacity": [
			"interpolate",
			["linear"],
			["zoom"],
			4,
			0,
			5.5,
			1
		],
		"text-color": "hsl(247, 17%, 25%)",
		"text-halo-color": "hsl(0, 0%, 100%)",
		"text-halo-width": 1,
		"text-halo-blur": 2,
		"text-translate": [0, -15],
		"text-translate-anchor": "map"
	},
	vesselTrails: {
		"line-color": ["string", ["get", "lineColor"], "#000000"],
		"line-width": 1
	},
	vesselTrailsBlack: {
		"line-color": ["string", ["get", "lineColor"], "#000000"],
		"line-width": 2
	},
	trails: {
		"line-color": "#AFA",
		"line-width": 1,
		"line-opacity": 1.0
	},
	trailsHighlighted: {
		"line-color": "#F88",
		"line-width": 2
	},
	nearbyBounds: {
		lines: {
			"line-color": "rgba(0, 0, 0, 0.5)",
			"line-width": 1
		}
	},
	measure: {
		lines: {
			"line-color": ["get", "color"],
			"line-width": 2
		},
		points: {
			"circle-radius": 8,
			"circle-color": "#ccc"
		},
		text: {
			"text-color": ["get", "color"],
			"text-halo-width": 1,
			"text-halo-color": "rgba(255, 255, 255, 1.0)",
			"text-halo-blur": 0
		}
	},
	ukho: {
		windTurbines: {
			"circle-radius": 3,
			"circle-color": "rgba(0, 255, 0, 0.35)",
			"circle-stroke-color": "rgba(0, 200, 0, 1.0)",
			"circle-stroke-width": 1
		},
		oagSurfaces: {
			"circle-radius": 5,
			"circle-color": "rgba(255, 255, 0, 0.35)",
			"circle-stroke-color": "rgba(200, 200, 0, 1.0)",
			"circle-stroke-width": 1
		},
		oagPlatforms: {
			"circle-radius": 5,
			"circle-color": "rgba(0, 0, 255, 0.35)",
			"circle-stroke-color": "rgba(0, 0, 200, 1.0)",
			"circle-stroke-width": 1
		}
	},
	roi: {
		"fill-color": "#111111",
		"fill-opacity": ["interpolate", ["linear"],
			["zoom"],
			4, 0.2,
			6, 0.03
		],
		"fill-outline-color": "black"
	},
	hotspots: {
		orange: {
			"fill-color": "#ff7711",
			"fill-opacity": ["interpolate", ["linear"],
				["zoom"],
				1, 0.8,
				8, 0.5
			],
			"fill-outline-color": "black"
		},
		green: {
			"fill-color": "#11ff11",
			"fill-opacity": ["interpolate", ["linear"],
				["zoom"],
				1, 0.8,
				8, 0.5
			],
			"fill-outline-color": "black"
		},
		blue: {
			"fill-color": "#1111ff",
			"fill-opacity": ["interpolate", ["linear"],
				["zoom"],
				1, 0.8,
				8, 0.5
			],
			"fill-outline-color": "black"
		}
	},
	ttw: {
		"fill-color": "red",
		"fill-opacity": 0.4
	},
	eez: {
		"fill-color": "yellow",
		"fill-opacity": 0.4
	},
	tz: {
		"fill-color": "yellow",
		"fill-opacity": 0.4
	},
	sanctions: {
		"fill-color": "yellow",
		"fill-opacity": 0.4
	},
	borderLine: {
		"line-color": "#000000",
		"line-width": 2
	},
	notam: {
		"fill-color": ["get", "color"],
		"fill-opacity": 0.4
	},
	// https://docs.mapbox.com/help/tutorials/make-a-heatmap-with-mapbox-gl-js/
	heatmap: {
		"heatmap-intensity": 1,
		"heatmap-radius": {
			stops: [
				[1, 10],
				[22, 20]
			]
		},
		"heatmap-color": [
			"interpolate",
			["linear"],
			["heatmap-density"],
			0,
			"rgba(255,255,204,0)",
			0.2,
			"rgb(255,237,160)",
			0.4,
			"rgb(254,178,76)",
			0.6,
			"rgb(253,141,60)",
			0.9,
			"rgb(252,78,42)",
			1,
			"rgb(227,26,28)"
		],
		// Transition from heatmap to circle layer by zoom level
		"heatmap-opacity": [
			"interpolate",
			["linear"],
			["zoom"],
			7, 1, // at Zoom level 7, it's full opaque.
			9, 0 // at Zoom level 9 it's complete transparent
		]
	},
	heatmapPoints: {
		"icon-image": "dot-11",
		"icon-size": ["step",
			["zoom"],
			0,
			7, 1
		],
		"icon-opacity": [
			"interpolate",
			["linear"],
			["zoom"],
			7, 0, // at Zoom level 7, it's full transparent.
			9, 1 // at Zoom level 9 it's fully opaque.
		]
	},

	rfVesselPolys: {
		"fill-color": "#ff8888",
		"fill-outline-color": "red",
		 "fill-opacity": 0.25// ["interpolate", ["linear"],
		// 	["zoom"],
		// 	7, 1, // at Zoom level 7, it's full opacque.
		// 	23, 0.5 // at Zoom level 9 it's half opaque
		// ]
	},
	customLines: {
		"line-color": ["string", ["get", "color"], "#000000"], // "black",
		"line-opacity": ["interpolate", ["linear"],
			["zoom"],
			4, 1.0,
			6, 0.1
		],
		// "line-dasharray": []
		"line-width": 2
	},
	customLinePoints: {
		"circle-radius": 8,
		"circle-color": "#ccc",
		"circle-opacity": ["interpolate", ["linear"],
			["zoom"],
			4, 1.0,
			6, 0.1
		]
	},
	customFills: {
		"fill-color": ["string", ["get", "color"], "#000000"], // ["get", "color"],//"black",
		"fill-opacity": ["interpolate", ["linear"],
			["zoom"],
			4, 0.2,
			6, 0.03
		],
		"fill-outline-color": ["string", ["get", "color"], "#000000"] // "black"
	},
	timezone: {
		"fill-color": ["get", "fill"],
		"fill-opacity": ["get", "fill-opacity"]
	},
	timezoneLines: {
		"line-width": ["get", "stroke-width"],
		"line-color": ["get", "stroke"],
		"line-opacity": ["get", "stroke-opacity"]
	}
};
// const ESRIColorScale = [
// 	0,
// 	"rgba(61,113,30,0)",
// 	5,
// 	"rgb(61,113,30)",
// 	10,
// 	"rgb(91,165,48)",
// 	20,
// 	"rgb(124,225,69)",
// 	30,
// 	"rgb(255,253,85)",
// 	40,
// 	"rgb(231,228,76)",
// 	50,
// 	"rgb(161,114,37)",
// 	60,
// 	"rgb(220,154,54)",
// 	70,
// 	"rgb(212,45,31)",
// 	80,
// 	"rgb(107,43,13)",
// 	90,
// 	"rgb(120,32,162)",
// 	100,
// 	"rgb(120,32,162)"
// ];
const ColorScaleSimple = [
	0,
	"rgba(59,180,96,0)",
	5,
	"rgb(59,180,96)",
	10,
	"rgb(124,225,69)",
	30,
	"rgb(255,253,85)",
	50,
	"rgb(233,159,46)",
	70,
	"rgb(212,45,31)",
	90,
	"rgb(120,32,162)",
	100,
	"rgb(120,32,162)"
];
Paint.hurricanes = {
	cone: {
		"fill-color": "#111111",
		"fill-opacity": 0.2,
		"fill-outline-color": "black"
	},
	// probability: {
	// 	"fill-color": [
	// 		"interpolate",
	// 		["linear"],
	// 		["get", "PWIND120"],
	// 		0,
	// 		"rgba(255,255,204,0)",
	// 		20,
	// 		"rgb(255,237,160)",
	// 		40,
	// 		"rgb(254,178,76)",
	// 		60,
	// 		"rgb(253,141,60)",
	// 		90,
	// 		"rgb(252,78,42)",
	// 		100,
	// 		"rgb(227,26,28)"
	// 	]
	// },
	probability: {
		"fill-color": [
			"step",
			["get", "PWIND120"],
			"rgba(255,255,255,0)",
			...ColorScaleSimple
		]
	},
	lines: {
		"line-color": "#666",
		"line-width": 1
	},
	points: {
		"circle-radius": 3,
		"circle-color": "#333"
	}
};
Paint.portAssessments = {
	"circle-radius": 5,
	"circle-color": [
		"match",
		["get", "ThreatLevel"],
		"Low", "rgba(0, 255, 0, 0.35)",
		"Medium", "rgba(250, 255, 0, 0.35)",
		"High", "rgba(255, 127, 0, 0.35)",
		"Critical", "rgba(255, 0, 0, 0.35)",
		"rgba(127, 127, 127, 0.35)"
	],
	"circle-stroke-color": "rgba(0, 0, 0, 1.0)",
	"circle-stroke-width": 1.5
};
Paint.hazards = {
	volcanoes: {
		"circle-radius": 5,
		"circle-color": "rgba(255, 0, 0, 0.35)",
		"circle-stroke-color": "rgba(150, 0, 0, 1.0)",
		"circle-stroke-width": 1.5
	},
	earthquakes: {
		"circle-radius": 5,
		"circle-color": "rgba(250, 200, 0, 0.35)",
		"circle-stroke-color": "rgba(150, 120, 0, 1.0)",
		"circle-stroke-width": 1.5
	},
	floods: {
		"circle-radius": 5,
		"circle-color": "rgba(0, 0, 255, 0.35)",
		"circle-stroke-color": "rgba(0, 0, 150, 1.0)",
		"circle-stroke-width": 1.5
	},
	miss: {
		"circle-radius": 3,
		"circle-color": "rgba(255, 0, 0, 0.35)",
		"circle-stroke-color": "rgba(150, 0, 0, 1.0)",
		"circle-stroke-width": 1
	},
	generic: {
		"circle-radius": 5,
		"circle-color": "rgba(127, 127, 127, 0.35)",
		"circle-stroke-color": "rgba(64, 64, 64, 1.0)",
		"circle-stroke-width": 1.5
	}
};
export { Layout, Paint, Styles, ColorScaleSimple };
